<template>
  <div v-if="isOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-card" @click.stop>
      <button class="clear-button absolute-top-right" @click="closeModal">
        <icon name="close-x" variant="98A2B3" />
      </button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'BaseModal',
  components: {
    Icon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-card {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  color: rgba(71, 84, 103, 1);
  border-radius: 12px;
  padding: 20px;
  max-width: 90%;
  max-height: 90%;
  overflow-x: hidden;
  overflow-y: auto;
  font-size: var(--Fontsizetext-md);
  line-height: var(--Lineheighttext-md);
  margin: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.absolute-top-right {
  position: absolute;
  top: 10px;
  right: 10px;
}

.clear-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
}

@include breakpoint(tablet) {
  .modal-card {
    max-width: 60%;
    max-height: 60%;
  }
}

@include breakpoint(desktop) {
  .modal-card {
    max-width: 600px;
    max-height: 60%;
  }
}
</style>
